(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.mobileMenu = this.querySelector('header-drawer');
      this.currentScrollTop = 0;
      this.preventHide = false;
      this.preventReveal = false;

      this.headerCoords = {};
      this.calcHeaderCoords();

      this.onScrollHandler = this.onScroll.bind(this);
      this.enableScroll();
    }

    disconnectedCallback() {
      this.disableScroll();
    }

    calcHeaderCoords() {
      const clientRect = this.getBoundingClientRect();
      const pageYOffset = window.pageYOffset || document.documentElement.scrollTop;
      this.headerCoords.bottom = pageYOffset + clientRect.bottom;
      this.headerCoords.top = pageYOffset + clientRect.top;
    }

    onScroll(event) {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.headerIsAlwaysSticky) {
        if (scrollTop > this.header.offsetHeight + 1) {
          this.header.classList.add('shopify-section-header-sticky');
        }

        if (scrollTop < this.header.offsetHeight) {
          this.header.classList.remove('shopify-section-header-sticky');
        }
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerCoords.bottom) {
        if (this.preventHide || (this.mobileMenu && this.mobileMenu.isOpen && window.innerWidth <= 1160)) {
          return;
        }
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerCoords.bottom) {
        if (this.preventReveal) {
          return;
        }
        requestAnimationFrame(this.reveal.bind(this));
      } else if (scrollTop <= this.headerCoords.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    enableScroll() {
      window.addEventListener('scroll', this.onScrollHandler, false);
    }

    disableScroll() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["renew-header"]) return;
  try {
    
function renewHeaderInit(){
 const header=document.querySelector('.rn-header-section'),menu=header?.querySelector('.rn-explore');
 if(!header||!menu||menu.dataset.ready)return;
 menu.dataset.ready='true';
 const summary=menu.querySelector('summary'),panel=menu.querySelector('.rn-mega'),frame=header.querySelector('.rn-header'),mobile=matchMedia('(max-width:989px)'),hover=matchMedia('(hover:hover) and (pointer:fine) and (min-width:990px)');
 const backdrop=document.createElement('div');backdrop.className='rn-menu-backdrop';backdrop.hidden=true;backdrop.setAttribute('aria-hidden','true');document.body.append(backdrop);
 let timer,closeTimer,savedScroll=0,locked=false,bodyStyles,inertElements=[];
 const viewport=()=>header.style.setProperty('--rn-menu-viewport',`${visualViewport?.height||innerHeight}px`);
 const unlock=()=>{if(!locked)return;locked=false;header.classList.remove('rn-mobile-menu-open');backdrop.hidden=true;frame.removeAttribute('role');frame.removeAttribute('aria-modal');frame.removeAttribute('aria-label');Object.assign(document.body.style,bodyStyles);inertElements.forEach(([e,value])=>e.inert=value);inertElements=[];window.scrollTo({top:savedScroll,behavior:'instant'})};
 const lock=()=>{if(locked||!mobile.matches)return;savedScroll=scrollY;locked=true;bodyStyles={position:document.body.style.position,top:document.body.style.top,width:document.body.style.width,overflow:document.body.style.overflow};Object.assign(document.body.style,{position:'fixed',top:`-${savedScroll}px`,width:'100%',overflow:'hidden'});header.classList.add('rn-mobile-menu-open');backdrop.hidden=false;frame.setAttribute('role','dialog');frame.setAttribute('aria-modal','true');frame.setAttribute('aria-label',header.querySelector('.rn-primary').getAttribute('aria-label'));document.querySelectorAll('main,.shopify-section-group-footer-group').forEach(e=>{if(!e.contains(header)){inertElements.push([e,e.inert]);e.inert=true}});viewport();panel.scrollTop=0};
 const open=()=>{clearTimeout(timer);clearTimeout(closeTimer);menu.classList.remove('rn-closing');menu.open=true;summary.setAttribute('aria-expanded','true');lock()};
 const close=(immediate=false)=>{clearTimeout(timer);clearTimeout(closeTimer);summary.setAttribute('aria-expanded','false');if(locked||immediate||matchMedia('(prefers-reduced-motion:reduce)').matches){menu.open=false;menu.classList.remove('rn-closing');unlock();return}menu.classList.add('rn-closing');closeTimer=setTimeout(()=>{menu.open=false;menu.classList.remove('rn-closing')},280)};
 summary.setAttribute('aria-expanded','false');
 summary.addEventListener('pointerenter',()=>{if(hover.matches)timer=setTimeout(open,90)});
 header.addEventListener('pointerleave',()=>{if(hover.matches)timer=setTimeout(()=>close(),150)});
 panel.addEventListener('pointerenter',()=>{clearTimeout(timer);clearTimeout(closeTimer);menu.classList.remove('rn-closing')});
 summary.addEventListener('click',e=>{e.preventDefault();if(menu.open)close();else open()});
 header.addEventListener('click',e=>{if(e.target.closest('a'))close(true)});
 header.addEventListener('focusout',()=>{setTimeout(()=>{if(!locked&&!header.contains(document.activeElement))close()},0)});
 document.addEventListener('click',e=>{if(!header.contains(e.target))close(true);if(e.target.closest('.rn-cart-concierge a'))document.querySelector('cart-drawer')?.close?.()});
 document.addEventListener('keydown',e=>{if(e.key==='Escape'&&menu.open){close(true);summary.focus()}if(e.key==='Tab'&&locked){const items=[...header.querySelectorAll('a[href],summary,button')].filter(e=>e.getClientRects().length);const first=items[0],last=items.at(-1);if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus()}else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus()}}});
 mobile.addEventListener('change',()=>{if(menu.open)close(true)});
 visualViewport?.addEventListener('resize',viewport);window.addEventListener('resize',viewport);
 new ResizeObserver(()=>{const padding=getComputedStyle(header);document.documentElement.style.setProperty('--rn-header-height',`${header.querySelector('.rn-header-inner').getBoundingClientRect().height+parseFloat(padding.paddingTop)+parseFloat(padding.paddingBottom)}px`)}).observe(header.querySelector('.rn-header-inner'));
}
renewHeaderInit();document.addEventListener('shopify:section:load',renewHeaderInit);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["renew-science"] && !Shopify.designMode) return;
  try {
    
function renewRevealInit(){if(matchMedia('(prefers-reduced-motion: reduce)').matches)return;const observer=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('rn-reveal');observer.unobserve(e.target)}}),{threshold:.12});document.querySelectorAll('.rn-science-card,.rn-journal-hero,.rn-athlete-copy,.rn-faq-heading,.rn-compare .rn-science-intro').forEach(el=>observer.observe(el))}renewRevealInit();document.addEventListener('shopify:section:load',renewRevealInit);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["renew-section-nav"] && !Shopify.designMode) return;
  try {
    
function renewSectionNav() {
  document.querySelectorAll('.rn-section-nav:not([data-ready])').forEach(nav => {
    nav.dataset.ready = 'true';
    const disclosure = nav.querySelector('.rn-jump');
    const summary = disclosure.querySelector('summary');
    const currentLabel = nav.querySelector('[data-section-current]');
    const links = [...nav.querySelectorAll('.rn-section-links a, .rn-jump-links a')];
    const targets = [...nav.querySelectorAll('.rn-section-links a')].map(a => document.querySelector(a.hash)).filter(Boolean);
    let raf;
    const offset = () => (document.querySelector('.rn-header-section')?.getBoundingClientRect().height || 0) + nav.getBoundingClientRect().height + 14;
    const mark = hash => {
      links.forEach(a => {
        if (a.hash === hash) {
          a.setAttribute('aria-current', 'location');
          currentLabel.textContent = a.textContent;
        } else a.removeAttribute('aria-current');
      });
    };
    const update = () => {
      let current = targets[0];
      for (const target of targets) if (target.getBoundingClientRect().top <= offset() + 90) current = target;
      if (current) mark('#' + current.id);
    };
    const close = (restoreFocus = false) => {
      disclosure.open = false;
      if (restoreFocus) summary.focus({preventScroll: true});
    };
    const jump = hash => {
      const target = document.querySelector(hash);
      if (!target) return;
      history.replaceState(null, '', hash);
      mark(hash);
      window.scrollTo({top: Math.max(0, scrollY + target.getBoundingClientRect().top - offset()), behavior: matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth'});
    };
    links.forEach(a => a.addEventListener('click', e => {
      e.preventDefault();
      const fromMobile = disclosure.contains(a);
      close(fromMobile);
      jump(a.hash);
    }));
    nav.querySelector('.rn-section-buy')?.addEventListener('click', e => {e.preventDefault(); jump(e.currentTarget.hash)});
    nav.addEventListener('keydown', e => {
      if (e.key === 'Escape' && disclosure.open) {e.preventDefault(); close(true)}
    });
    document.addEventListener('pointerdown', e => {if (disclosure.open && !disclosure.contains(e.target)) close()});
    document.addEventListener('focusin', e => {if (disclosure.open && !disclosure.contains(e.target)) close()});
    window.addEventListener('resize', () => {if (innerWidth >= 990) close()});
    window.addEventListener('scroll', () => {cancelAnimationFrame(raf); raf = requestAnimationFrame(update)}, {passive:true});
    update();
  });
}
renewSectionNav();
document.addEventListener('shopify:section:load', renewSectionNav);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["renew-tour"] && !Shopify.designMode) return;
  try {
    
function renewTourInit(){document.querySelectorAll('.rn-tour:not([data-ready])').forEach(root=>{root.dataset.ready='true';const tabs=[...root.querySelectorAll('[role=tab]')],panels=[...root.querySelectorAll('[role=tabpanel]')],points=[...root.querySelectorAll('.rn-tour-point')];const select=(index,focus=false)=>{tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index?0:-1;panels[i].hidden=i!==index;points[i]?.setAttribute('aria-pressed',String(i===index))});if(focus)tabs[index].focus()};root.addEventListener('click',e=>{const target=e.target.closest('[data-tour-target]');if(target)select(Number(target.dataset.tourTarget))});root.querySelector('[role=tablist]').addEventListener('keydown',e=>{const idx=tabs.indexOf(document.activeElement);if(idx<0)return;let next=idx;if(e.key==='ArrowRight'||e.key==='ArrowDown')next=(idx+1)%tabs.length;else if(e.key==='ArrowLeft'||e.key==='ArrowUp')next=(idx-1+tabs.length)%tabs.length;else if(e.key==='Home')next=0;else if(e.key==='End')next=tabs.length-1;else return;e.preventDefault();select(next,true)});select(0)})}renewTourInit();document.addEventListener('shopify:section:load',renewTourInit);

  } catch(e) { console.error(e); }
})();
})();
